{
  "version": 1,
  "asset_id": "709c42bd-79a1-40ed-bcc4-d9e6be619e50",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/709c42bd-79a1-40ed-bcc4-d9e6be619e50/sleeve-gastrectomy-v2-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/709c42bd-79a1-40ed-bcc4-d9e6be619e50/sleeve-gastrectomy-v2-1200.jpg",
  "original_filename": "sleeve-gastrectomy-v2-1200.jpg",
  "size": 111873,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:06:44Z"
}
